import { useMemo } from "react";
import useDocs from "./useDocs";
import { DocsKind, DocsTag } from "./constants";
import { flattenCommentArray, extractType } from "./utils";

const useFunctionDocs = (entry, namespace) => {
  const docs = useDocs(entry, DocsKind.Function, namespace);

  return useMemo(() => {
    if (!docs) return null;
    const { name, signatures } = docs;

    const signature =
      Array.isArray(signatures) && signatures.length > 0 ? signatures[0] : {};

    const { comment, parameters, type } = signature;

    const blockTags = comment?.blockTags ?? [];
    //const paramTags = blockTags.filter((t) => t.tag === DocsTag.Param);

    const returnTag = blockTags.find((t) => t.tag === DocsTag.Returns);
    const returnType = extractType(type);

    return {
      name,
      description: flattenCommentArray(comment?.summary),
      parameters: parameters?.map((p) => {
        // const paramTag = paramTags.find(
        //   (t) =>
        //     t.content?.length > 1 &&
        //     t.content[0].kind === DocsContentKind.Code &&
        //     t.content[0].text?.startsWith("`" + p.name)
        // );
        return {
          name: p.name,
          type: extractType(p.type),
          description: flattenCommentArray(p.comment?.summary),
          optional: !!p.flags?.isOptional,
        };
      }),
      returns:
        returnTag || returnType
          ? {
              type: returnType,
              description: flattenCommentArray(returnTag?.content),
            }
          : null,
    };
  }, [docs]);
};

export default useFunctionDocs;
